export default "__VITE_ASSET__B_fhVd3K__"